import {
  createRouter,
  createWebHashHistory,
  RouteRecordRaw,
  Router,
} from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "root",
    component: () => import("@/views/LicensingHome.vue"),
  },
  {
    path: "/login/microsoft",
    name: "login-microsoft",
    component: () => import("@/components/LoginMicrosoft.vue"),
  },
];

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
async function handleNavigation(to, from) {
  const publicPages = ["/login/microsoft"];
  const loggedIn = localStorage.microsoftUser;
  const authRequired = !publicPages.includes(to.path);
  console.log("authReq:", authRequired);
  console.log("loggedIn:", loggedIn);
  if (!authRequired) {
    console.log("----GIVE ROOT----");
    return { name: "root" };
  } else if (authRequired && (!loggedIn || loggedIn === "null")) {
    console.log("----GIVE LOGIN---");
    router.push({ path: "/login/microsoft" });
  }
}

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
router.beforeEach((to, from) => {
  // redirect to login page if not logged in and trying to access a restricted page
  console.log("TO", to);
  console.log("FROM", from);

  handleNavigation(to, from);
});

export default router;
